import { formatDate } from 'core/utils/date'

export function formatScheduledAt(
  appointmentDate: string,
  appointmentTime: string,
  facilityTimezone?: string
) {
  return `${formatDate(
    new Date(appointmentDate as string),
    'EEEE, MMM d yyyy'
  )} @ ${appointmentTime} (${facilityTimezone?.replace(/[-_]/g, ' ')})`
}
